import { toast } from 'react-toastify';
import APIClient from '../../Services/AxiosClient';
import { URL_ENDPOINTS } from '../../Utils/EndPoints';

export const fetchNatNal = async (queryPayload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.NATNAL?.GETNATNALDATA,
      method: 'post',
      data: queryPayload,
    });
    if (response?.status === 'Success') {
      return response;
    } else {
      response?.message && toast(response?.message);
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const overrideNatNal = async (payload: any) => {
  try {
    const response: any = await APIClient({
      url: URL_ENDPOINTS?.NATNAL?.OVERRIDENATNALDATA,
      method: 'post',
      data: payload?.queryPayloads,
    });
    response && payload?.callback && payload?.callback({ ...response });
    return response;
  } catch (err) {
    console.error('Activity : ', err);
    return null;
  }
};
